import React, { Component, createRef } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import Wizard from './helpers/Wizard';
import * as actions from '../actions';
import LetterOfAppealDisplay from './letter_of_appeal/LetterOfAppealDisplay';
import letterOfAppealDocX from '../assets/docs/ACAC-0048-Letter-of-Appeal-Template-9-20.docx';

class LetterOfAppeal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      pdfUrl: false,
      letterOfAppealItems: null
    }
  }
  
  scrollToTop = ()=> {
    this.toTop.current.scrollIntoView({ behavior: "smooth" }); 
  }

  onSubmit = async(values) => {
    const reactState = this;
    let url = "/";
    if(process.env.NODE_ENV === "development") {
      url = "http://localhost:8000/"
    }
    values.formType = 'letterofappeal';
    values.age = this.calculateAge(new Date(values.dob));
    try {
      await Axios({
          method: 'post',
          url: url + "api/generate_pdf",
          data: values,
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          }
        })
        .then(function(res) {
          reactState.setState({
            ...reactState.state,
            pdfUrl: url + res.data.file,
            submitted: true
          });
          reactState.scrollToTop()
        });
      } catch (errors) {
        console.log("errors", errors)
      }
  }

    calculateAge = (age) => { // birthday is a date
        var ageDifMs = Date.now() - age.getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    handleChange = (event) => {
        const {name, value} = event.target
        this.setState({
            letterOfAppealItems: {
                [name]: value
            }
        });
    }

    toTop = createRef();
    
  render() {
    const { submitted, pdfUrl } = this.state;

    const formIdentifier = 'LetterOfAppeal';

    return ( 
        <>
        <div ref={this.toTop} class="row spacer-medium">&nbsp;</div>
        <div class="row">
          <div class="col-sm-12">
            <h1 class="copy-blue">letter of appeal.</h1>
          </div>
        </div>
        <div class="row spacer-medium">&nbsp;</div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form"> 
              <div  className="acadia-form">
                <h3>It's easy to complete the letter</h3>
                <p>If your patient needs a Letter of Appeal, just fill in the fields, and we'll generate a letter you can use instantly. You can preview it and create a PDF. You can also <a href={letterOfAppealDocX} target = "_blank" rel="noopener noreferrer">download a blank Letter of Appeal</a>. All information is required unless marked optional.
                </p>
                <div className="row spacer-medium">&nbsp;</div>
                <div id="formTop" >
                    <Wizard onSubmit={this.onSubmit} noOfPages={1} formIdentifier={formIdentifier} submitted={submitted} customSubmitLabel="Create PDF" >
                        <Wizard.Page>
                            <LetterOfAppealDisplay submitted={submitted} pdfUrl={pdfUrl} /> 
                        </Wizard.Page>
                    </Wizard> 
                </div>
              </div> 
            </div>
          </div>
        </div>
        </> 
    );
  }
}

const mapStateToProps = (state) => {
  const { currentStep } = state;
  return { currentStep: currentStep };
}

export default connect(mapStateToProps, actions)(LetterOfAppeal);